module.exports = __webpack_public_path__ + "static/media/blog6.bc029ac9.jpg";